import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export default class UserService {
  static async follow(userId: string): Promise<boolean> {
    const [resp] = await http.post(ApiRoutes.apiFollowUser(), { user_id: userId })
    return !!resp
  }

  static async unfollow(userId: string): Promise<boolean> {
    const [resp] = await http.post(ApiRoutes.apiUnfollowUser(), { user_id: userId })
    return !!resp
  }
}
